export default {
  on: true,
  cache: true,
  auth: true,
  intercept: false,
  title: '组织业务关系管理',
} as TCommon.RouteConfig
